import { memo } from 'react'

import GameCardSection from './GameCardSection'

const GameCardSectionComponent = memo(GameCardSection)

export { GameCardSection }

export default GameCardSectionComponent
